/*
 * @Author: jiangfeng
 * @Date: 2024-09-27 10:47:31
 * @LastEditTime: 2024-10-30 18:17:06
 * @LastEditors: jiangfeng
 * @FilePath: /governance-driver-projects/packages/acceptor-center/src/service/http.js
 */

// import axios from '@didi/dajax';
import { getDidiXFetch } from '@didi/mpx-fetch/dist/web.js';
import dialog from '@/components/ui/dialog/index';
// import connect from '@didi/sandbox-link';
import globalVaribles from '../utils/globalVaribles';

const GPUX_PAGE_CONFIG = process.env.GPUX_PAGE_CONFIG;
const { extra: { biz } } = GPUX_PAGE_CONFIG;
// const Axios = connect(axios, { noconsole: false });

const getOsimEnv = () => {
  const arr = /^(osim\d+)\.zhili-m-test\.intra\.xiaojukeji\.com/.exec(
    location.host
  );
  return arr && arr[1] ? arr[1] : '';
};


// 初始化
const xfetch = getDidiXFetch({
  mode: 'web',
  needSign: true, // 签名能力，默认为true 可设置false关闭
  needDclg: false, // 挑战应答，默认为true 可设置false关闭
  signOptions: {
    // 安全biz: 4af896a6b828b0bccb8b613e9bff5909 
    // 治理biz: bd88a5b0c93251b9eebbbf3d3f2ae04b
    bizId: 'bd88a5b0c93251b9eebbbf3d3f2ae04b',
    // 以后追溯的tag
    appVer: '0.1.0', // 业务方自定义，方便问题排查时定位版本tag
    // 微信小程序 1 阿里 2 星河 3 h5和pc等 4 Rn or weex等 5
    os: '3'
  }
});

xfetch.interceptors.request.use(
  config => {
    return {
      timeout: 20000,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
      ...config
    }
  },
  error => {
    return Promise.reject(error);
  }
);

// get,post封装
const http = {
  get: (url, params = {}, config = {}) => {
    return xfetch.fetch({
      url,
      params,
      method: 'get',
      ...config
    });
  },
  post: (url, data = {}, config = {}) => {
    return xfetch.fetch({
      url,
      data,
      method: 'post',
      emulateJSON: false,
      ...config
    });
  }
};

export function fetchGet(url, params) {
  // eslint-disable-next-line one-var
  const params_new = {
    ...params,
    ...{
      product_line: biz || 'wyc'
    }
  };
  return new Promise((resolve, reject) => {
    http.get(url, {
      params: params_new,
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        dialog.alert({ desc: '网络请求超时' });
        reject(error);
      });
  });
}

export function fetchPost({ url, params, option = {} }) {
  // eslint-disable-next-line one-var
  const params_new = {
    ...params,
    ...{
      product_line: biz || 'wyc'
    },
    ...globalVaribles.mockParams
  };
  if (getOsimEnv()) {
    option.headers =  Object.assign(option.headers || {}, {
      'nuwa-wings': `env=${getOsimEnv()}-v`,
    })
  }
  return new Promise((resolve, reject) => {
    http.post(url, params_new, option)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        dialog.alert({ desc: '网络请求超时' });
        reject(error);
      });
  });
}
